module.exports = __webpack_public_path__ + "SchoolComparisonReport2-c1d79ce769eebf7db4e06ac3f3349c6e.png";